import { Component } from '@angular/core';

interface AdminIntegration {
  provider: string;
  icon: string;
  iconBg: string;
  iconColor: string;
  status: 'connected' | 'disconnected' | 'error';
  orgsConnected: number;
  lastVerified: string;
  detail: string;
}

@Component({
  selector: 'app-integration-control',
  templateUrl: './integration-control.component.html',
})
export class IntegrationControlComponent {
  readonly integrations: AdminIntegration[] = [
    {
      provider: 'GitHub',
      icon: 'github',
      iconBg: 'bg-zinc-900',
      iconColor: 'text-white',
      status: 'connected',
      orgsConnected: 7,
      lastVerified: '2 min ago',
      detail: '14 open PRs · GitHub App v2 OAuth',
    },
    {
      provider: 'Jira',
      icon: 'list-todo',
      iconBg: 'bg-blue-600',
      iconColor: 'text-white',
      status: 'connected',
      orgsConnected: 4,
      lastVerified: '15 min ago',
      detail: '7 sprints active · Atlassian Cloud',
    },
    {
      provider: 'AWS',
      icon: 'cloud',
      iconBg: 'bg-amber-500',
      iconColor: 'text-white',
      status: 'connected',
      orgsConnected: 8,
      lastVerified: '5 min ago',
      detail: 'Cross-account IAM role · multi-account, per-account regions',
    },
    {
      provider: 'Azure',
      icon: 'cloud',
      iconBg: 'bg-blue-500',
      iconColor: 'text-white',
      status: 'connected',
      orgsConnected: 3,
      lastVerified: '6 min ago',
      detail: 'Service principal · multi-subscription, per-subscription locations',
    },
    {
      provider: 'Google Cloud',
      icon: 'cloud',
      iconBg: 'bg-red-500',
      iconColor: 'text-white',
      status: 'connected',
      orgsConnected: 2,
      lastVerified: '8 min ago',
      detail: 'Service account · multi-project, per-project regions',
    },
  ];

  statusBadge(status: AdminIntegration['status']): string {
    const map: Record<string, string> = {
      connected: 'bg-emerald-100 text-emerald-700',
      disconnected: 'bg-zinc-100 text-zinc-500',
      error: 'bg-red-100 text-red-700',
    };
    return map[status] ?? 'bg-zinc-100 text-zinc-500';
  }

  statusDot(status: AdminIntegration['status']): string {
    const map: Record<string, string> = {
      connected: 'bg-emerald-500',
      disconnected: 'bg-zinc-400',
      error: 'bg-red-400',
    };
    return map[status] ?? 'bg-zinc-400';
  }
}
